import React from 'react'
import { IconSearch } from '@tabler/icons-react'

import './styles/search.css'

function Search() {

    return (

        <section className='--search'>

            <div className='--content-search'>
                <h2>
                    <span>Ahora estás buscando trabajo</span>
                    <span>en el Perú.</span>
                </h2>

                <div className='--searchbox'>
                    <div className='--txtbox-A'>
                        <span className='--ico'><IconSearch/></span>
                        <input type='text' className='--entry' placeholder='Buscar por posicion, compañia o titulo' aria-label='Buscar por posicion, compañia o titulo' aria-placeholder='Buscar por posicion, compañia o titulo' autoComplete='off' />
                    </div>
                    <button className='--btn-search'>Buscar</button>
                </div>

            </div>

        </section>

    )

}

export default Search